import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import './Deals.css';
import AdminAppBar from './components/adminComponents/AdminAppBar';
import AdminLeadUploadPanel from './components/adminComponents/AdminLeadUploadPanel'
import AdminBulkUpload from './components/LeadUploadComponents/AdminBulkUpload';
import AdminManualUpload from './components/LeadUploadComponents/AdminManualUpload';
import AdminPanel from './components/adminComponents/AdminPanel';
import LeadSplit from './components/BOD/BodComponents/LeadSplit';

import LeadUploadPanel from './components/CommonComponents/LeadUploadPanel';

import LeadDbMain from './components/LeadsDbComponents/LeadDbMain';

import Login from './components/loginComponent/Login';
import ForgetPassword from './components/loginComponent/ForgetPassword';
import KanbanBoard from './components/pipelineComponents/KanbanBoard';



import Analytics from './components/AnalyticsComponent/Analytics';

import TagInput from './components/SetupComponents/Interest & Sources Component/TagInput';
import Pipeline from './components/pipelineComponents/Pipeline';

import MyProfile from './components/SetupComponents/MyProfile';
import Card from './components/pipelineComponents/Card';
// import Property from './components/SetupComponents/PropertyComponent/Property';
// import Counter from './components/SetupComponents/PropertyComponent/AddCounter';

import BodBulkUpload from './components/BOD/BodComponents/BodBulkUpload';
import BodLeadUploadPanel from './components/BOD/BodComponents/BodLeadUploadPanel';
import BodManualUpload from './components/BOD/BodComponents/BodManualUpload';
import BodPanel from './components/BOD/BodComponents/BodPanel';
import LeadInfo from './components/LeadsDbComponents/LeadInfoSection/LeadInfo';
import 'primereact/resources/themes/saga-blue/theme.css';  // or any other theme you prefer
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import ResetPassword from './components/loginComponent/ResetPassword';
import ErrorPage from './ErrorPage';
import ReportMain from './components/ReportComponent/ReportMain';
import ReAssignLead from './components/LeadsDbComponents/ReAssignLead';
import LeadSplitToTeam from './components/LeadsDbComponents/LeadSplitToTeam'
import MarketingHub from './components/SetupComponents/MarketingHubComponent/MarketingHub';
import MarketingHubInfo from './components/SetupComponents/MarketingHubComponent/MarketingHubInfo';
import CreateTextAndImageTemplate from './components/SetupComponents/MarketingHubComponent/CreateTextAndImageTemplate';
import TemplateBulkSend from './components/SetupComponents/MarketingHubComponent/TemplateBulkSend';
import UpdateTextAndImageTemplate from './components/SetupComponents/MarketingHubComponent/UpdateTextAndImageTemplate';
import SpinWheel from './components/SetupComponents/SpinWheelComponent/SpinWheel';
import SpinWheelCreation from './components/SetupComponents/SpinWheelComponent/SpinWheelCreation';
import CreateDocumentTemplate from './components/SetupComponents/MarketingHubComponent/CreateDocumentTemplate';
import SpinWheelEditor from './components/SetupComponents/SpinWheelComponent/SpinWheelEditor';
import GLpageCreatingSection from './components/SetupComponents/GLpagesComponents/GLpageCreatingSection';
import GLpagesViewList from './components/SetupComponents/GLpagesComponents/GLpagesViewList';

import ReAssignIndividualLead from './components/LeadsDbComponents/ReAssignIndividualLead';
import ImageUploaderTemplate from './components/SetupComponents/MarketingHubComponent/ImageUploaderTemplate';
import LinkUploaderTemplate from './components/SetupComponents/MarketingHubComponent/LinkUploaderTemplate';
import ChannelPartnerMainPage from './components/SetupComponents/ChannelPartnerComponent/ChannelPartnerMainPage';
import NewPermissionList from './components/SetupComponents/ChannelPartnerComponent/NewPermissionList';
import UnassignLeadsList from './components/SetupComponents/ChannelPartnerComponent/UnassignLeadsList';
import AssignTeamMemberPage from './components/SetupComponents/ChannelPartnerComponent/AssignTeamMemberPage';
import Leadfilter from './components/LeadsDbComponents/Leadfilter';
import AssignSummary from './components/LeadsDbComponents/AssignSummary';
import UnassignedLead from './components/LeadsDbComponents/UnassignedLead';
import ReasignMain from './components/LeadsDbComponents/LeadReasignSection/ReasignMain';
import AutoMessageMain from './components/SetupComponents/AutomatedMessageComponents/AutoMessageMain';

import PiplineUserDeals from './components/pipelineComponents/PiplineUserDeals';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import GLpagesCreateTamplate from './components/SetupComponents/GLpagesComponents/GLpagesCreateTamplate';
import IntegrationMainPage from './components/SetupComponents/WebHooksComponent/IntegrationMainPage';
import ConnectedPage from './components/SetupComponents/WebHooksComponent/ConnectedPage';
import FormLeadList from './components/SetupComponents/WebHooksComponent/FormLeadList';
import PropertiesListCard from './components/SetupComponents/PropertiesComponents/PropertiesListCard';
import LayoutPropertyManage from './components/SetupComponents/PropertiesComponents/LayoutPropertySection/LayoutPropertyManage';
import PropertyInventory from './components/SetupComponents/Property Inventory/PropertyInventory';
import VillaProertyManage from './components/SetupComponents/PropertiesComponents/VillaPropertySection/VillaProertyManage';
import ApartmentPropertyManage from './components/SetupComponents/PropertiesComponents/ApartmentPropertySection/ApartmentPropertyManage';

import HotLeadList from './components/HotLeadComponent/HotLeadList';
import SetupNavigationManager from './components/SetUpNavigationComponent/SetupNavigationManager';
import CustomAPIMainContent from './components/SetupComponents/CustomAPIComponents/CustomAPIMainContent';
import InterestAndSourceMain from './components/SetupComponents/Interest&SourceComponents/InterestAndSourceMain';
import TeamList from './components/SetupComponents/TeamComponents/TeamList';
import UserList from './components/SetupComponents/UserComponents/UserList';
import BulkLeadUploadHistoryList from './components/LeadsDbComponents/BulkLeadUploadedHistorySection/BulkLeadUploadHistoryList';
import BulkLeadUploadData from './components/LeadsDbComponents/BulkLeadUploadedHistorySection/BulkLeadUploadData';
import AssignMain from './components/LeadsDbComponents/LeadAssignSection/AssignMain';
import AssignSummaryList from './components/LeadsDbComponents/AssignSummarySection/AssignSummaryList';
import EstimateList from './components/SetupComponents/PropertiesComponents/EstimateSection/EstimateList';
import UserAnalyticsData from './components/BOD/AnalyticsComponent/UserAnalyticsData';
import FollowUpsMain from './components/FollowupsComponent/FollowUpsMain';
import IntegrationModule from './components/SetupComponents/WebHooksComponent/IntegrationModule';
import CallLogsSummaryList from './components/BOD/AnalyticsComponent/CallLogsSummaryDownload/CallLogsSummaryList';
import GLNavigationSystem from './GLFunnelDashboardComponents/GLNavigationSystem';
import UserInfo from './components/SetupComponents/UserComponents/UserManage';


// {Procurement Path}

import PropertyProcurementPage from './PropertyProcurementComponents/PropertyProcurementSection/PropertyManagement/PropertyProcurementPage';
import PropertyInfoPage from './PropertyProcurementComponents/PropertyProcurementSection/PropertyInfoSection/PropertyInfoPage';
import ProcurementPropertyInfoPage from './PropertyProcurementComponents/PropertyInfoManagement/PropertyInfoPage';
import ProcurementAnalyticsPage from './PropertyProcurementComponents/Analytics/AnalyticsPage';
import ProcurementSetupPage from './PropertyProcurementComponents/SetUp/SetupPage';
import AdvocatesPage from './PropertyProcurementComponents/SetUp/Advocates/AdvocatesPage';
import ProcurementLocation from './PropertyProcurementComponents/SetUp/Interest&SourceComponents/InterestAndSourceMain';
import ProcurementReportPage from './PropertyProcurementComponents/Report/ReportPage';
import ProcurementQueryPage from './PropertyProcurementComponents/ProcurementQueryList/ProcurementQueryPage';

import PresentationPropertyLayout from './PropertyProcurementComponents/PropertyProcurementSection/PropertyInfoSection/PropertyStep/PresentationPreparation/PropertiesComponents/LayoutPropertySection/LayoutPropertyManage';
import PresentationAcresAndCents from './PropertyProcurementComponents/PropertyProcurementSection/PropertyInfoSection/PropertyStep/PresentationPreparation/PropertiesComponents/AcresAndCentsSection/AcresAndCentsManage';
import PresentationResalePlot from './PropertyProcurementComponents/PropertyProcurementSection/PropertyInfoSection/PropertyStep/PresentationPreparation/PropertiesComponents/ResalePlotSection/ResalePlotManage';


import RoughPropertyHistory from './PropertyProcurementComponents/RoughDraft/RoughPropertyHistory';

import ProcurementProfilePage from './PropertyProcurementComponents/MyProfile';

// {GeoLocation Path}

import DashboardPage from './GeoLocationCompoents/Dashboard/DashboardPage';
import LiveTrackingPage from './GeoLocationCompoents/LiveTracking/LiveTrackingPage';
import ReportPage from './GeoLocationCompoents/Report/ReportPage';
import SetupPage from './GeoLocationCompoents/SetUp/SetupPage';
import TeamPage from './GeoLocationCompoents/SetUp/Teams/TeamPage';
import GeoProfilePage from './GeoLocationCompoents/MyProfile';


// {HR Path}

import HRReport from './HRComponents/Report/ReportPage';
import HRUserInfoPage from './HRComponents/UserInfo/UserInfoPage';
import HRAnalyticsPage from './HRComponents/Attendance/AnalyticsPage';
import HRSetupPage from './HRComponents/SetUp/SetupPage';
import AllowancePage from './HRComponents/Allowance/AllowancePage';
import RequestList from './HRComponents/Attendance/RequestListSection/RequestList';
import ShiftTimePage from './HRComponents/SetUp/ShiftTime/ShiftTimePage';
import AllowanceRequestList from './HRComponents/Allowance/AllowanceRequestListSection/AllowanceRequestList';
import RoughdraftPage from './PropertyProcurementComponents/RoughDraft/RoughdraftPage';
import HRProfile from './HRComponents/MyProfile';


// { Global Setup Path}

import GlobalSetupPage from './GlobalSetupComponents/SetUp/SetupPage';
import GlobalTeamPage from './GlobalSetupComponents/TeamComponents/TeamList';
import GlobalUserPage from './GlobalSetupComponents/UserComponents/UserList';
import GlobalUserManage from './GlobalSetupComponents/UserComponents/UserManage';
import RoughPropertyInfoPage from './PropertyProcurementComponents/RoughDraft/RoughPropertyInfoManagement/RoughLayoutPage/RoughPropertyInfoPage'
import AcresCentsPage from './PropertyProcurementComponents/RoughDraft/RoughPropertyInfoManagement/RoughAcresAndCentsPage/AcresCentsPage';
import ResalePlotPage from './PropertyProcurementComponents/RoughDraft/RoughPropertyInfoManagement/RoughResalePlotPage/ResalePlotPage';
import OverallSittingPage from './PropertyProcurementComponents/OverallSittingManagement/OverallSittingPage';
import ProspectLayoutPage from './PropertyProcurementComponents/PropertyProcurementSection/ProspectPropertySection/ProspectLayout/ProspectLayoutPage';
import ProspectAcresAndCents from './PropertyProcurementComponents/PropertyProcurementSection/ProspectPropertySection/ProspectAcresAndCents/ProspectAcresAndCents';
import ProspectResalePlotPage from './PropertyProcurementComponents/PropertyProcurementSection/ProspectPropertySection/ProspectResalePlot/ProspectResalePlotPage';


import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; 
import ResalePlotManage from './components/SetupComponents/PropertiesComponents/ResalePlotSection/ResalePlotManage';
import AcresAndCentsManage from './components/SetupComponents/PropertiesComponents/AcresAndCentsSection/AcresAndCentsManage';
import AttachmentsListPage from './PropertyProcurementComponents/ProspectAttachmentSection/AttachmentsListPage';



const queryClient = new QueryClient();
// import BodPipeline from './components/BOD/BodComponents/pi';


function App() {
  const userRole = JSON.parse(localStorage?.getItem("userData"))?.user?.role;
 

  return (
    <div className="App font-inter bg-appGrayBackground h-screen">
      <ToastContainer/>
      <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path='/login' element={<Login />} />

    
        <Route path='/forget-password' element={<ForgetPassword />} />
        <Route path='/reset-password' element={<ResetPassword />} />


        <Route path='/global-setup' element={<GlobalSetupPage />} />
        <Route path='/global-setup/teams' element={<GlobalTeamPage />} />
        <Route path='/geo-setup/users' element={<GlobalUserPage />} />
        <Route path='/global-setup/user-info' element={<GlobalUserManage />} />



        <Route path='/dashboard' element={<GLNavigationSystem />} />
        <Route path='/propertyprocurement-list' element={<PropertyProcurementPage />} />
        <Route path='/propertyprocurement-list-info' element={<PropertyInfoPage />} />
        <Route path='/propertyprocurement-list/property-info' element={<ProcurementPropertyInfoPage />} />

        <Route path='/procurement-raughDraft' element={<RoughdraftPage />} />
        <Route path='/procurement-raughDraft/property-info' element={<RoughPropertyInfoPage />} />
        <Route path='/procurement-raughDraft/acres-and-cents' element={<AcresCentsPage />} />
        <Route path='/procurement-raughDraft/resale-plot' element={<ResalePlotPage />} />

        <Route path='/prospect/layout' element={<ProspectLayoutPage />} />
        <Route path='/prospect/acres-and-cents' element={<ProspectAcresAndCents />} />
        <Route path='/prospect/resale-plot' element={<ProspectResalePlotPage />} />


        <Route path='/procurement-analytics' element={<ProcurementAnalyticsPage />} />
        <Route path='/procurement-report' element={<ProcurementReportPage />} />
        <Route path='/procurement-setup' element={<ProcurementSetupPage />} />
        <Route path='/procurement-setup/advocates' element={<AdvocatesPage/>} />
        <Route path='/procurement-setup/locations' element={<ProcurementLocation/>} />
  
        <Route path='/procurement-sitting' element={<OverallSittingPage />} />
        <Route path='/procurement-query' element={<ProcurementQueryPage />} />

        <Route path='/presentation-property/layout' element={<PresentationPropertyLayout />} />
         <Route path='/presentation-property/acres-and-cents' element={<PresentationAcresAndCents />} />
        <Route path='/presentation-property/resale-plot' element={<PresentationResalePlot />} />
        <Route path='/presentation-property/attachments-history' element={<AttachmentsListPage />} />

        <Route path='/procurement-raughDraft/rough-property-history' element={<RoughPropertyHistory/>} />

        <Route path='/propertyprocurement-list/my-profile' element={<ProcurementProfilePage/>} />
        









        <Route path='/geo-location-dashboard' element={<DashboardPage />} />
        {/* <Route path='/geo-location-analytics/request-list' element={<RequestList />} /> */}
       
        <Route path='/geo-location-live-tracking' element={<LiveTrackingPage />} />
        <Route path='/geo-location-report' element={<ReportPage />} />
        <Route path='/geo-location-setup' element={<SetupPage/>} />
        <Route path='/geo-location-setup/team' element={<TeamPage />} />
        <Route path='/geo-location-my-profile' element={<GeoProfilePage/>} />


  
        <Route path='/hr-employee-analytics' element={<HRAnalyticsPage />} />
        <Route path='/hr-employee-allowance' element={<AllowancePage />} />
        <Route path='/hr-employee-allowance/request-list' element={<AllowanceRequestList />} />
        
        <Route path='/hr-employee-analytics/user-info' element={<HRUserInfoPage />} />
        <Route path='/hr-employee-analytics/request-list' element={<RequestList />} />
        <Route path='/hr-employee-report' element={<HRReport />} />
        <Route path='/hr-employee-setup' element={<HRSetupPage/>} />
        <Route path='/hr-employee-setup/shift-time' element={<ShiftTimePage />} />
        <Route path='/hr-employee-my-profile' element={<HRProfile/>} />





        {userRole === "Lead Uploader" && (
          <>
          <Route path='/lead-uploader' element={<AdminLeadUploadPanel/>}/>
          <Route path='lead-uploader/lead-upload/manual' element={<AdminManualUpload/>}/>
          <Route path='/lead-uploader/lead-upload/bulk' element={<AdminBulkUpload/>}/>
          <Route path='/lead-uploader/lead-bulk-upload-history' element={<BulkLeadUploadHistoryList/>}/>
          <Route path='/lead-uploader/lead-bulk-upload-data' element={<BulkLeadUploadData/>}/>
          <Route path='/lead-uploader/my-profile' element={<MyProfile/>}/>
        <Route path='/' element={<Navigate to="/lead-uploader"/>}/>

          <Route path='/*' element={<ErrorPage />} />


                    </>
        )}
        {userRole === "Admin" && (
          <>
            <Route path='/admin/dashboard' element={<AdminPanel />} />
            <Route path='/admin/analytics' element={<Analytics />} />
            <Route path='/admin/pipeline' element={<Pipeline />} />
            <Route path='/admin/lead-db' element={<LeadDbMain />} />
            <Route path='/admin/report' element={<ReportMain />} />

            <Route path='/admin/lead-upload' element={<LeadUploadPanel/>} />

            <Route path='/admin/lead-upload/manual' element={<AdminManualUpload />} />

            <Route path='/admin/lead-upload/bulk' element={<AdminBulkUpload />} />
            <Route path='/admin/lead-info/:leadId' element={<LeadInfo />} />
            <Route path ='/admin/lead/reassign' element = {<ReAssignIndividualLead/>}/>
            {/* <Route path='/admin/not-interested' element={<NotInterestedLeads />} />
            <Route path='/admin/retry-suitable' element={<RetrySuitableLead />} /> */}
            <Route path='/admin/reassign-lead' element={<ReAssignLead />} />
            <Route path='/admin/leadSplit-teamWise' element={<LeadSplitToTeam />} />


            {/* <Route path='/admin/sale-team' element={<SaleTeam />} /> */}
            <Route path='/admin/sale-team' element={<TeamList />} />
            <Route path='/admin/call-logs-list' element={<CallLogsSummaryList/>} />
         
          
            <Route path='/admin/users' element={<UserList />} />
            <Route path='/admin/users/user-info' element={<UserInfo />} />
            <Route path='/admin/follow-ups' element={<FollowUpsMain />} />
       

            <Route path='/admin/properties-list' element={<PropertiesListCard/>} />


            <Route path='/admin/layout-properties-manage' element={<LayoutPropertyManage/>} />
            <Route path='/admin/villa-properties-manage' element={<VillaProertyManage/>} />
            <Route path='/admin/apartment-properties-manage' element={<ApartmentPropertyManage />} />
            <Route path='/admin/resale-properties-manage' element={<ResalePlotManage />} />
            <Route path='/admin/acres-and-cents-properties-manage' element={<AcresAndCentsManage />} />



            <Route path='/admin/property-inventory' element={<PropertyInventory />} />



            <Route path='/admin/web-hooks' element={<IntegrationMainPage/>} />
            <Route path='/admin/web-hooks-connected-page' element={<ConnectedPage/>} />
            <Route path='/admin/web-hooks-integration-module' element={<IntegrationModule/>}/>
            <Route path='/admin/web-hooks-form-list' element={<FormLeadList/>} />

            

            {/* <Route path='/admin/interest-sources' element={<InterestAndSources />} /> */}
            <Route path='/admin/interest-sources' element={<InterestAndSourceMain />} />

            <Route path='/admin/tag-input' element={<TagInput />} />
            <Route path='/admin/marketingHub-groupinfo/:id' element={<MarketingHubInfo />} />
            <Route path='/admin/create-textAndImage-template' element={<CreateTextAndImageTemplate />} />
            <Route path='/admin/update-textAndImage-template' element={<UpdateTextAndImageTemplate />} />
            <Route path='/admin/create-document-template' element={<CreateDocumentTemplate />} />
            <Route path='/admin/image-template' element={<ImageUploaderTemplate />} />
            <Route path='/admin/link-template' element={<LinkUploaderTemplate />} />

            <Route path='/admin/hot-lead' element={<HotLeadList/>} />

            <Route path='/admin/marketing-hub' element={<MarketingHub />} />
            <Route path='/admin/marketing-hub-bulkSend' element={<TemplateBulkSend />} />
            <Route path='/admin/spin-wheel' element={<SpinWheel/>}/>
            <Route path='/admin/spin-wheel-creation' element={<SpinWheelCreation/>}/>
            <Route path='/admin/spin-wheel-editor' element={<SpinWheelEditor/>}/>

            <Route path='/admin/gl-pages-creating' element={<GLpageCreatingSection/>}/>
            <Route path='/admin/gl-pages' element={<GLpagesViewList/>}/>
            <Route path='/admin/gl-pages-template' element={<GLpagesCreateTamplate/>}/>
            <Route path='/admin/auto-message' element={<AutoMessageMain/>}/>
            <Route path='/admin/cp-management' element={<ChannelPartnerMainPage/>}/>
            <Route path='/admin/cp-new-permission-list' element={<NewPermissionList/>}/>
            <Route path='/admin/cp-unassignleads-list' element={<UnassignLeadsList/>}/>
            <Route path='/admin/cp-assign-team-member' element={<AssignTeamMemberPage />} />
            <Route path='/admin/lead/lead-filter' element={<Leadfilter />} />

            <Route path='/admin/lead-assign-summary' element={<AssignSummaryList />} />
            <Route path='/admin/lead-unassign-lead' element={<AssignMain />} />
            <Route path='/admin/lead-reasign-lead' element={<ReasignMain />} />

            <Route path="/admin/user-analytics" element={<UserAnalyticsData />} />
            <Route path='/admin/pipline-user-deal' element={<PiplineUserDeals />} />

            <Route path='/admin/estimate-list' element={<EstimateList />} />


            <Route path='/admin/set-up-manage' element={<SetupNavigationManager/>} />

            <Route path='/admin/custom-api' element={<CustomAPIMainContent /> }/>

            <Route path='/admin/lead-bulk-upload-history' element={<BulkLeadUploadHistoryList />} />
            <Route path='/admin/lead-bulk-upload-data' element={<BulkLeadUploadData />} />


            <Route path='/admin/kanban-board' element={<KanbanBoard />} />

            <Route path='/admin/my-profile' element={<MyProfile />} />
        <Route path='/' element={<Navigate to="/admin/dashboard"/>}/>

            <Route path='/*' element={<ErrorPage />} />
          </>
        )}


{userRole === "CMO" && (
       <>
       <Route path='/cmo/dashboard' element={<AdminPanel />} />
       <Route path='/cmo/analytics' element={<Analytics />} />
       <Route path='/cmo/pipeline' element={<Pipeline />} />
       <Route path='/cmo/lead-db' element={<LeadDbMain />} />
       <Route path='/cmo/report' element={<ReportMain />} />

       <Route path='/cmo/lead-upload' element={<LeadUploadPanel/>} />

       <Route path='/cmo/lead-upload/manual' element={<AdminManualUpload />} />

       <Route path='/cmo/lead-upload/bulk' element={<AdminBulkUpload />} />
       <Route path='/cmo/lead-info/:leadId' element={<LeadInfo />} />
       <Route path ='/cmo/lead/reassign' element = {<ReAssignIndividualLead/>}/>
       {/* <Route path='/cmo/not-interested' element={<NotInterestedLeads />} />
       <Route path='/cmo/retry-suitable' element={<RetrySuitableLead />} /> */}
       <Route path='/cmo/reassign-lead' element={<ReAssignLead />} />
       <Route path='/cmo/leadSplit-teamWise' element={<LeadSplitToTeam />} />
  {/* <Route path='/cmo/sale-team' element={<SaleTeam />} /> */}
  <Route path='/cmo/sale-team' element={<TeamList />} />
            
           
            {/* <Route path='/cmo/users' element={<UserMain />} /> */}
            <Route path='/cmo/users' element={<UserList />} />
            <Route path='/cmo/call-logs-list' element={<CallLogsSummaryList/>} />

            <Route path='/cmo/follow-ups' element={<FollowUpsMain />} />

       <Route path='/cmo/properties-list' element={<PropertiesListCard/>} />


       <Route path='/cmo/layout-properties-manage' element={<LayoutPropertyManage/>} />
       <Route path='/cmo/villa-properties-manage' element={<VillaProertyManage/>} />
       <Route path='/cmo/apartment-properties-manage' element={<ApartmentPropertyManage />} />
        <Route path='/cmo/resale-properties-manage' element={<ResalePlotManage />} />
        <Route path='/cmo/acres-and-cents-properties-manage' element={<AcresAndCentsManage />} />



       <Route path='/cmo/property-inventory' element={<PropertyInventory />} />

       <Route path='/cmo/estimate-list' element={<EstimateList />} />

       <Route path="/cmo/user-analytics" element={<UserAnalyticsData />} />

       <Route path='/cmo/web-hooks' element={<IntegrationMainPage/>} />
       <Route path='/cmo/web-hooks-connected-page' element={<ConnectedPage/>} />
       <Route path='/cmo/web-hooks-form-list' element={<FormLeadList/>} />

       <Route path='/cmo/interest-sources' element={<InterestAndSourceMain />} />

       <Route path='/cmo/tag-input' element={<TagInput />} />
       <Route path='/cmo/marketingHub-groupinfo/:id' element={<MarketingHubInfo />} />
       <Route path='/cmo/create-textAndImage-template' element={<CreateTextAndImageTemplate />} />
       <Route path='/cmo/update-textAndImage-template' element={<UpdateTextAndImageTemplate />} />
       <Route path='/cmo/create-document-template' element={<CreateDocumentTemplate />} />
       <Route path='/cmo/image-template' element={<ImageUploaderTemplate />} />
       <Route path='/cmo/link-template' element={<LinkUploaderTemplate />} />

       <Route path='/cmo/hot-lead' element={<HotLeadList/>} />

       <Route path='/cmo/marketing-hub' element={<MarketingHub />} />
       <Route path='/cmo/marketing-hub-bulkSend' element={<TemplateBulkSend />} />
       <Route path='/cmo/spin-wheel' element={<SpinWheel/>}/>
       <Route path='/cmo/spin-wheel-creation' element={<SpinWheelCreation/>}/>
       <Route path='/cmo/spin-wheel-editor' element={<SpinWheelEditor/>}/>

       <Route path='/cmo/gl-pages-creating' element={<GLpageCreatingSection/>}/>
       <Route path='/cmo/gl-pages' element={<GLpagesViewList/>}/>
       <Route path='/cmo/gl-pages-template' element={<GLpagesCreateTamplate/>}/>
       <Route path='/cmo/auto-message' element={<AutoMessageMain/>}/>
       <Route path='/cmo/cp-management' element={<ChannelPartnerMainPage/>}/>
       <Route path='/cmo/cp-new-permission-list' element={<NewPermissionList/>}/>
       <Route path='/cmo/cp-unassignleads-list' element={<UnassignLeadsList/>}/>
       <Route path='/cmo/cp-assign-team-member' element={<AssignTeamMemberPage />} />
       <Route path='/cmo/lead/lead-filter' element={<Leadfilter />} />

       <Route path='/cmo/lead-assign-summary' element={<AssignSummaryList />} />
       <Route path='/cmo/lead-unassign-lead' element={<AssignMain />} />
       <Route path='/cmo/lead-reasign-lead' element={<ReasignMain />} />


       <Route path='/cmo/pipline-user-deal' element={<PiplineUserDeals />} />


       <Route path='/cmo/set-up-manage' element={<SetupNavigationManager/>} />

       <Route path='/cmo/custom-api' element={<CustomAPIMainContent /> }/>

       <Route path='/cmo/lead-bulk-upload-history' element={<BulkLeadUploadHistoryList />} />
       <Route path='/cmo/lead-bulk-upload-data' element={<BulkLeadUploadData />} />


       <Route path='/cmo/kanban-board' element={<KanbanBoard />} />

       <Route path='/cmo/my-profile' element={<MyProfile />} />
   <Route path='/' element={<Navigate to="/cmo/dashboard"/>}/>

       <Route path='/*' element={<ErrorPage />} />
     </>
        )}

        {userRole === "MD" && (
          <>
            <Route path='/md/dashboard' element={<AdminPanel />} />
            <Route path='/md/analytics' element={<Analytics />} />
            <Route path="/md/user-analytics" element={<UserAnalyticsData />} />
            <Route path='/md/pipeline' element={<Pipeline />} />
            <Route path='/md/lead-db' element={<LeadDbMain />} />
            <Route path='/md/lead-info/:leadId' element={<LeadInfo />} />
            <Route path='/md/follow-ups' element={<FollowUpsMain />} />

            <Route path='/md/my-profile' element={<MyProfile />} />
        <Route path='/' element={<Navigate to="/md/dashboard"/>}/>

            <Route path='/*' element={<ErrorPage />} />
          </>
        )}

        {userRole === "BOD" && (
          <>
            <Route path='/bod/dashboard' element={<BodPanel />} />
            <Route path='/bod/forget-password' element={<ForgetPassword />} />
            <Route path='/bod/lead-upload' element={<LeadUploadPanel/>} />
            <Route path='/bod/lead-upload/manual' element={<AdminManualUpload />} />
            <Route path='/bod/lead-split' element={<LeadSplit />} />
            <Route path='/bod/lead-upload/bulk' element={<AdminBulkUpload />} />
            <Route path='/bod/analytics' element={<Analytics />} />
            <Route path='/bod/pipeline' element={<Pipeline />} />

            <Route path='/bod/lead-db' element={<LeadDbMain />} />
            <Route path='/bod/lead-info/:leadId' element={<LeadInfo />} />
            <Route path ='/bod/lead/reassign' element = {<ReAssignIndividualLead/>}/>
            <Route path='/bod/lead-assign-summary' element={<AssignSummaryList />} />
            <Route path='/bod/lead-unassign-lead' element={<AssignMain />} />
            <Route path='/bod/lead-reasign-lead' element={<ReasignMain />} />
            <Route path="/bod/user-analytics" element={<UserAnalyticsData />} />
            <Route path='/bod/call-logs-list' element={<CallLogsSummaryList/>} />
          
            <Route path='/bod/follow-ups' element={<FollowUpsMain />} />
            <Route path='/bod/lead-bulk-upload-history' element={<BulkLeadUploadHistoryList />} />
            <Route path='/bod/lead-bulk-upload-data' element={<BulkLeadUploadData />} />

            <Route path='/bod/my-profile' element={<MyProfile />} />
        <Route path='/' element={<Navigate to="/bod/dashboard"/>}/>

            <Route path='/*' element={<ErrorPage />} />
          </>
        )}
       <Route path='/*' element={<Login />} />

      </Routes>
      </QueryClientProvider>
    </div>
  );
}

export default App;

